
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class Bag_HistoryGrid extends Serenity.EntityGrid<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.Bag_History'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return BagHistoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
            this.slickGrid.setOptions({ rowHeight: 30, enableCellNavigation: true });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //this.view.setGrouping([  {
            //    getter: 'BagNo',

            //    displayTotalsRow: false

            //}])
             
            for (let col of columns) {
                //console.log(col);
                if (col.field == "TransDate" || col.field == "BagNo"  ) col.groupName = "Bag Details";
                if (col.field == "FromDeptName" || col.field == "FromPieces"
                    || col.field == "FromWeight" || col.field == "FromNetWeight"
                    || col.field == "FromEmployeeName" || col.field == "FromPieces" || col.field == "Loss") col.groupName = "Issue Details";

                if (col.field == "ToDeptName" || col.field == "ToPieces"
                    || col.field == "ToWeight" || col.field == "ToNetWeight"
                    || col.field == "ToEmployeeName") col.groupName = "Receipt Details"; 
            }

            plugin.enableColumnGrouping();

            grid.setColumns(columns);
            //grid.registerPlugin(this.autoSize); 
            return grid;
        }


        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Filters',
                cssClass: 'send-button',
                icon: 'fa-filter',
                onClick: () => {
                    var dialog = new Common.FiltersDialog;
                    dialog.filterformfor = "Production";
                    dialog.dialogOpen();

                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        if (dialog.checksuccess) {

                            var bagnos = dialog.form.BagNo.selectedItems.map(x=>x.BagNo);

                            //this.onViewSubmit();
                            //this.view.refresh();
                            BagHistoryService.List({ BagNos: bagnos }, response => {
                                this.view.setItems(response.Entities)
                            }, { async: false });
                        }
                    });
                }
            });
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle:"Bag History"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: BagHistoryService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}